import { createSlice } from '@reduxjs/toolkit';
import {
  getSamples,
  deleteSamples,
  addSample,
  updateSample,
  getSampleByID,
  importSamples
} from './samplesThunk';

const initialState = {
  samples: {
    data: [],
    total: 0, // Ajouté pour la pagination
    loading: false,
    error: null,
  },
  importSamples: {
    data: null,
    loading: false,
    error: null,
  },
  deletedSamples: {
    data: null,
    loading: false,
    error: null,
  },
  sample: {
    data: null,
    loading: false,
    error: null
  },
  updatedSamples: {
    data: null,
    loading: false,
    error: null
  },
  sampleByID: {
    data: null,
    loading: false,
    error: null
  }
};

const samplesSlice = createSlice({
  name: 'samples',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // --- GET SAMPLES CORRIGÉ ---
      .addCase(getSamples.pending, (state) => {
        state.samples.loading = true;
        state.samples.error = null;
      })
      .addCase(getSamples.fulfilled, (state, action) => {
        // CORRECTION : On met à jour les champs internes au lieu de remplacer l'objet
        state.samples.data = action.payload.data;
        state.samples.total = action.payload.total;
        state.samples.loading = false;
      })
      .addCase(getSamples.rejected, (state, action) => {
        state.samples.loading = false;
        state.samples.error = action.payload;
      })

      // --- DELETE ---
      .addCase(deleteSamples.pending, (state) => {
        state.loading = true; // Note: cet indicateur semble global, vérifiez s'il doit être state.samples.loading
        state.error = null;
      })
      .addCase(deleteSamples.fulfilled, (state, action) => {
        state.deletedSample = action.payload;
        state.loading = false;
      })
      .addCase(deleteSamples.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // --- ADD ---
      .addCase(addSample.pending, (state) => {
        state.sample.loading = true;
        state.sample.error = null;
      })
      .addCase(addSample.fulfilled, (state, action) => {
        state.sample.data = action.payload;
        state.sample.loading = false;
      })
      .addCase(addSample.rejected, (state, action) => {
        state.sample.loading = false;
        state.sample.error = action.payload;
      })

      // --- UPDATE ---
      .addCase(updateSample.pending, (state) => {
        state.updatedSamples.loading = true;
        state.updatedSamples.error = null;
      })
      .addCase(updateSample.fulfilled, (state, action) => {
        state.updatedSamples.data = action.payload;
        state.updatedSamples.loading = false;
      })
      .addCase(updateSample.rejected, (state, action) => {
        state.updatedSamples.loading = false;
        state.updatedSamples.error = action.payload;
      })

      // --- GET BY ID ---
      .addCase(getSampleByID.pending, (state) => {
        state.sampleByID.loading = true;
        state.sampleByID.error = null;
      })
      .addCase(getSampleByID.fulfilled, (state, action) => {
        state.sampleByID.data = action.payload;
        state.sampleByID.loading = false;
      })
      .addCase(getSampleByID.rejected, (state, action) => {
        state.sampleByID.loading = false;
        state.sampleByID.error = action.payload;
      })

      // --- IMPORT ---
      .addCase(importSamples.pending, (state) => {
        state.importSamples.loading = true;
        state.importSamples.error = null;
      })
      .addCase(importSamples.fulfilled, (state, action) => {
        state.importSamples.data = action.payload;
        state.importSamples.loading = false;
      })
      .addCase(importSamples.rejected, (state, action) => {
        state.importSamples.loading = false;
        state.importSamples.error = action.payload;
      })
  },
});

export default samplesSlice.reducer;